import React, { useState, useCallback } from 'react'
import shareIconSvg from '../../images/latest/share_icon.svg'
import { ResponsiveSVG } from 'ui/acro'
import { handleShareClick } from 'components_v2/share_content'

const ShareNative = ({
  plan_entry,
  shareKind = 'class',
  triggerButtonClass = 'log-class-button pdp-class-share-trigger-btn',
  wrapperClass = 'pdp-action pdp-action--share pdp-class-inline-share'
}) => {
  const shareTitle = plan_entry?.title
  const shareSource = `${shareKind}_page_action_bar`
  const openId = `${shareKind}-pdp-share-open-${plan_entry.id}`
  const emailSubject = `Check out this ${shareKind} on ALO Wellness Club`
  const overlayId = `${shareKind}-pdp-share-overlay-${plan_entry.id}`
  const shareUrl = plan_entry?.planEntryUrl || plan_entry?.planUrl
  const sharePresentation = window.matchMedia('(min-width: 767px)').matches
    ? 'modal'
    : 'sheet'

  const [isOpen, setIsOpen] = useState(false)
  const [copied, setCopied] = useState(false)

  const handleOpen = useCallback(() => {
    setIsOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setIsOpen(false)
    setCopied(false)
  }, [])

  const handleShareAction = async (action) => {
    const resp = await handleShareClick({
      url: shareUrl,
      title: shareTitle,
      kind: shareKind,
      emailSubject,
      share_presentation: sharePresentation,
      share_source: shareSource,
      action
    })
    if (resp === 'copy_link') {
      setCopied(true)
      setTimeout(() => {
        setCopied(false)
      }, 2000)
    }
  }

  return (
    <>
      <div className={wrapperClass}>
        <button
          type='button'
          className={triggerButtonClass}
          id={openId}
          onClick={handleOpen}
        >
          <ResponsiveSVG
            SVG={shareIconSvg}
            style={{
              cursor: 'pointer'
            }}
            width='24px'
            height='24px'
          />
          <span>Share</span>
        </button>
        <button
          type='button'
          className='class-pdp-share-native__sheet-launch'
          hidden
          tabIndex={-1}
          aria-hidden='true'
          data-class-pdp-share-open
          data-class-pdp-share-target={`#${overlayId}`}
          data-class-pdp-share-presentation='sheet'
          onClick={handleOpen}
        />
      </div>

      <div
        className={`class-pdp-share-native__root ${
          sharePresentation === 'sheet'
            ? 'class-pdp-share-native__root--sheet'
            : ''
        }`}
        style={{ display: isOpen ? undefined : 'none' }}
        id={overlayId}
        role='presentation'
      >
        <div
          className='class-pdp-share-native__backdrop'
          tabIndex={-1}
          aria-hidden='true'
          onClick={handleClose}
        />
        <div
          className='class-pdp-share-native__panel'
          role='dialog'
          aria-modal='true'
          aria-labelledby={`${overlayId}-title`}
        >
          <div className='class-pdp-share-native__head'>
            <h2
              className='class-pdp-share-native__title'
              id={`${overlayId}-title`}
            >
              Share
            </h2>
            <button
              type='button'
              className='class-pdp-share-native__close'
              aria-label='Close'
              onClick={handleClose}
            >
              <svg
                width='20'
                height='20'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                aria-hidden='true'
                focusable='false'
              >
                <path
                  d='M18 6L6 18M6 6l12 12'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                />
              </svg>
            </button>
          </div>
          <div className='class-pdp-share-native__actions'>
            {['facebook', 'message', 'email', 'copy_link'].map((action) => (
              <button
                key={action}
                type='button'
                className='class-pdp-share-native__action'
                data-share-action={action}
                onClick={() => handleShareAction(action)}
              >
                <span
                  className='class-pdp-share-native__icon-circle'
                  aria-hidden='true'
                >
                  {action === 'facebook' ? (
                    <svg
                      className='class-pdp-share-native__glyph class-pdp-share-native__glyph--fb'
                      width='22'
                      height='22'
                      viewBox='0 0 24 24'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      focusable='false'
                    >
                      <path
                        fill='#000'
                        d='M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z'
                      />
                    </svg>
                  ) : action === 'message' ? (
                    <svg
                      className='class-pdp-share-native__glyph'
                      width='24'
                      height='24'
                      viewBox='0 0 40 40'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      focusable='false'
                    >
                      <path
                        d='M35 25C35 25.8841 34.6488 26.7319 34.0237 27.357C33.3986 27.9821 32.5507 28.3333 31.6667 28.3333H11.6667L5 35V8.33333C5 7.44928 5.35119 6.60143 5.97631 5.97631C6.60143 5.35119 7.44928 5 8.33333 5H31.6667C32.5507 5 33.3986 5.35119 34.0237 5.97631C34.6488 6.60143 35 7.44928 35 8.33333V25Z'
                        stroke='#000'
                        strokeWidth='2.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  ) : action === 'email' ? (
                    <svg
                      className='class-pdp-share-native__glyph'
                      width='20'
                      height='20'
                      viewBox='0 0 40 40'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      focusable='false'
                    >
                      <path
                        d='M6.66634 6.66669H33.333C35.1663 6.66669 36.6663 8.16669 36.6663 10V30C36.6663 31.8334 35.1663 33.3334 33.333 33.3334H6.66634C4.83301 33.3334 3.33301 31.8334 3.33301 30V10C3.33301 8.16669 4.83301 6.66669 6.66634 6.66669Z'
                        stroke='#000'
                        strokeWidth='2.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M36.6663 10L19.9997 21.6667L3.33301 10'
                        stroke='#000'
                        strokeWidth='2.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  ) : (
                    <svg
                      className='class-pdp-share-native__glyph'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      focusable='false'
                    >
                      <path
                        d='M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z'
                        fill='#000'
                      />
                    </svg>
                  )}
                </span>
                <span className='class-pdp-share-native__label'>
                  {action === 'copy_link'
                    ? 'Copy Link'
                    : action.charAt(0).toUpperCase() + action.slice(1)}
                </span>
              </button>
            ))}
          </div>
          {copied && <p className='class-pdp-share-native__copied'>Copied!</p>}
        </div>
      </div>
    </>
  )
}

export default ShareNative
